<p-sidebar [visible]="showSidebar" position="left" (onHide)="onHide()" class="sidebar-headband" [modal]="false" *ngIf="ipsData && latestDepth">
  <ng-template pTemplate="headless" >
    <div class="header-container" [ngStyle]="{'background-color': headerBackgroundColor, 'color': textColor}">
      <div class="header-main">
        <div class="header-sidebar" >
          <span><b>{{ ipsData.libelle }}</b></span>
          <a 
          *ngIf="ipsData.alt_Identifier || ipsData.identifier"
          class="piezo-identifier"
          [href]="isPiezo 
            ? 'https://ades.eaufrance.fr/Fiche/PtEau?Code=' + (ipsData.alt_Identifier || ipsData.identifier) 
            : 'https://hydro.eaufrance.fr/stationhydro/' + (ipsData.identifier) + '/fiche'"
          target="_blank">
          {{ ipsData.alt_Identifier ? ipsData.alt_Identifier : ipsData.identifier }}
        </a>
        </div>
        <span>
          <p-button type="button" (onClick)="onHide()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary"></p-button>
        </span>
      </div>

      <div class="header-content">
        <div class="header-depth">
          <div class="depth-data" *ngIf="latestDepth.value">{{ latestDepth.value | number:'1.2-2' || 'XXX' }} {{ isPiezo ? "m" : "L/s"}}</div>
          <div class="depth-data" *ngIf="!latestDepth.value">XXX</div>
          <div class="depth-details" *ngIf="isPiezo">
            <span>{{ 'HEADBAND.DEPTH' | translate }}</span>
            <i class="pi pi-info-circle" (click)="openDepthInfoModal()"></i>
          </div>
          <div class="header-level-container">
            <span class="header-level">{{ 'HEADBAND.LEVEL.' + ipsData.libelleClasse | translate }}</span>
          </div>
          
        </div>
          <!-- <i [class]="iconClass" class="tendance"></i> -->
          <fa-icon class="tendance" [icon]="iconClass"></fa-icon>
      </div>
    </div>

    <ng-container *ngIf="chartData$ | async as chartData">
      <!-- Associe la logique de souscription ici -->
      <app-chart *ngIf="showDepthChart && isPiezo" [chartData]="chartData"></app-chart>
      <app-source-chart *ngIf="!isPiezo" [chartData]="chartData"></app-source-chart>
    </ng-container>

    <div class="content-container">
      <div class="graph-depth-details">
        <div *ngIf="latestDepth">{{ 'HEADBAND.LAST_RESULT' | translate }} {{ latestDepth.date | date:'dd/MM/yyyy' }}</div>
        <div *ngIf="hasDetails" (click)="showDetails()" class="show-detail">{{ 'HEADBAND.DEPTH_DETAILS' | translate }}</div>
        <div class="detail-content-scroll">
          <app-depth-detail *ngIf="showDepthDetail" [depth_detail]="chartData$ | async" [isPiezo]="isPiezo"></app-depth-detail>
        </div>
      </div>
      <p-button *ngIf="hasModel" class="btn-consult custom-btn-padding" label="{{ 'HEADBAND.CONSULT_BTN' | translate }}" icon="pi pi-chart-bar" (onClick)="openModeleInfoModal()" />
    </div>
    
  </ng-template>
</p-sidebar>

<app-depth-modal [showDialog]="showDepthModal" (showDialogChange)="hideDepthInfoModal()"></app-depth-modal>

<app-modele-modal *ngIf="showModeleModal" [showDialog]="showModeleModal" [ipsData]="ipsData" (showDialogChange)="hideModeleInfoModal()"></app-modele-modal>